/** An option's id, for the combobox's `aria-activedescendant` (#2555) */
export const optionId = (listboxId: string, index: number) => `${listboxId}-option-${index}`
